import { useState } from 'react';

const useCouponSelector = (couponChangeCallback = () => {}) => {
  const [couponsApplied, setCouponApplied] = useState([]);
  const [couponError, setCouponError] = useState({});
  const [discount, setDiscount] = useState(0);

  const handleApplyCoupon = (code, currentDiscount) => {
    if (couponsApplied.length) {
      setCouponError({ message: 'Only one promo code can be used at a time', type: 'only-one' });
    } else {
      const codeLowerCase = code.toLowerCase();
      setCouponApplied([{ message: `Promo code ${codeLowerCase} applied!`, type: 'coupon_code', code: codeLowerCase }]);
      setCouponError({});
      setDiscount(currentDiscount);
      couponChangeCallback(codeLowerCase);
    }
  };

  const handleRemoveCoupon = () => {
    setCouponApplied([]);
    setCouponError({});
    setDiscount(0);
    couponChangeCallback('');
  };

  return {
    handleApplyCoupon,
    handleRemoveCoupon,
    couponsApplied,
    couponError,
    discount,
  };
};

export default useCouponSelector;
